import { useTranslation } from "react-i18next";
import { FormHeading } from "../../shared/components/Typograhy";
import { DocumentLine } from "../../shared/components/DocumentLine";

export default function Documents() {
    const { t } = useTranslation();
    
    return (
        <div className="space-y-8">
            <FormHeading
                title={t("account_button.documents")}
            />
            <div className="overflow-hidden bg-white shadow sm:rounded-md">
                <ul role="list" className="divide-y divide-gray-200">
                    <DocumentLine href={"/documents/etiquettes-bagages.pdf"} label={`${t("account_button.download_labels")}`} />
                    <DocumentLine href={"/documents/plan-malpas-stationnement.pdf"} label={`${t("account_button.download_map")}`} />
                    <DocumentLine href={"/documents/minimalle.pdf"} label={`${t("account.download")} "La petite Malle illustrée"`} />
                </ul>
            </div>
        </div>
    );
}
